<template>
  <div class="site">
    <!-- 顶部导航：滚动后转实底，当前区块高亮（参考小米产品页交互） -->
    <header class="nav" :class="{ solid: navSolid }">
      <div class="nav-in">
        <div class="nav-brand" @click="scrollTop">
          <i class="ca ca-logo nav-logo-icon"></i>
          <span class="nav-name">{{ appName }}</span>
        </div>
        <nav class="nav-menu">
          <span v-for="(m, i) in menus" :key="i" class="nav-item" :class="{ on: active === m.id }"
            @click="go(m.id)">{{ m.name }}</span>
        </nav>
        <!-- 对外首页不放管理后台入口，登录地址由运营方自行掌握 -->
        <div class="nav-ops">
          <el-button class="nav-dl" size="small" @click="to('/download')">下载 APP</el-button>
        </div>
      </div>
    </header>

    <!-- 首屏：左侧下载信息 + 右侧手机效果图 -->
    <section class="hero" id="top">
      <div class="orb o1"></div>
      <div class="orb o2"></div>
      <!-- 图标库里的品牌 LOGO 作超大半透明水印，压在渐变底上 -->
      <i class="ca ca-logo hero-mark"></i>
      <div class="hero-in">
        <div class="hero-txt">
          <h1 class="h-hero">{{ appName }}</h1>
          <p class="p-hero">{{ slogan }}</p>
          <div class="hero-motto">{{ motto }}</div>
          <div class="hero-btns">
            <button class="btn solid" @click="to('/download')"><i class="el-icon-mobile-phone"></i> 下载 APP</button>
            <button class="btn line" @click="go('value')">了解伊颂</button>
          </div>
          <ul class="hero-chips">
            <li v-for="(c, i) in heroChips" :key="i"><i :class="c.icon"></i>{{ c.text }}</li>
          </ul>
        </div>
        <div class="hero-vis">
          <!-- imgs.hero 填入配图后自动替换 CSS 模拟效果图 -->
          <img v-if="imgs.hero" class="vis-img" :src="imgs.hero" :alt="slogan" />
          <div class="phone" v-else>
            <div class="phone-notch"></div>
            <div class="phone-screen">
              <div class="phone-head">
                <i class="ca ca-logo phone-logo"></i>
                <div>
                  <div class="phone-name">{{ appName }}</div>
                  <div class="phone-sub">{{ motto }}</div>
                </div>
              </div>
              <div class="phone-row" v-for="(r, i) in phoneRows" :key="i">
                <i :class="r.icon"></i>
                <span>{{ r.text }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="hero-down" @click="go('value')"><i class="el-icon-arrow-down"></i></div>
    </section>

    <!-- 价值观：使命 / 理念 / 愿景（口径取自官方演示介绍 PPT） -->
    <section class="sec" id="value">
      <div class="wrap narrow">
        <div class="kicker">价值主张 · 使命愿景</div>
        <h2 class="h-say">让优质单身<br /><b>高效遇见对的人</b></h2>
        <p class="p-center">伊颂是一款面向真诚单身人群的实名婚恋交友平台。<br />好的感情始于真诚，成于契合——每一次相遇都经过真实校验，每一次推荐都源于用心匹配。</p>
        <div class="value-grid">
          <div class="value-item" v-for="(v, i) in values" :key="i">
            <div class="value-key">{{ v.key }}</div>
            <div class="value-text">{{ v.text }}</div>
          </div>
        </div>
        <div class="vision-grid">
          <div class="vision-item" v-for="(v, i) in visions" :key="i">
            <div class="vision-key">{{ v.key }}</div>
            <div class="vision-text">{{ v.text }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- AI 能力（反诈风控面向 B 端与内部，不对 C 端展开宣传） -->
    <section class="sec alt" id="ai">
      <div class="wrap">
        <div class="block-head">
          <div class="kicker">核心技术 · AI 驱动</div>
          <h2 class="h2 center">AI 让真实可验证，让契合可计算</h2>
          <p class="p center">照片与资料逐层辨真伪，29 维度偏好算出契合，
            7×24 小时恋爱顾问陪你把沟通走顺。</p>
        </div>
        <div class="grid g3">
          <div class="gcard pad" v-for="(a, i) in aiPowers" :key="i">
            <div class="row-icon" :class="a.icon"></div>
            <div class="row-body">
              <div class="li-title">{{ a.title }}</div>
              <div class="li-text">{{ a.text }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 分屏一：真实（左文右视觉） -->
    <section class="sec alt" id="verify">
      <div class="wrap split">
        <div class="split-txt">
          <div class="kicker">服务特色 · 真实可信</div>
          <h2 class="h2">真实，是相遇的前提</h2>
          <p class="p">四重认证层层过滤虚假账号与不良用户，让每一个人都"确有其人"。</p>
          <ul class="list">
            <li v-for="(v, i) in verify" :key="i">
              <i class="li-icon" :class="v.icon"></i>
              <div>
                <div class="li-title">{{ v.title }}</div>
                <div class="li-text">{{ v.text }}</div>
              </div>
            </li>
          </ul>
        </div>
        <div class="split-vis">
          <img v-if="imgs.verify" class="vis-img" :src="imgs.verify" alt="四重实名认证" />
          <div class="doc-stack" v-else>
            <div class="doc-card c1"><i class="ca ca-idcard"></i><span>实名认证</span></div>
            <div class="doc-card c2"><i class="ca ca-face"></i><span>真人认证</span></div>
            <div class="doc-card c3"><i class="ca ca-edu"></i><span>学历认证</span></div>
            <div class="doc-card c4"><i class="ca ca-work"></i><span>工作认证</span></div>
          </div>
        </div>
      </div>
    </section>

    <!-- 大数字屏：全部取自官方文档的可数事实，不做任何估算型宣传数字 -->
    <section class="sec">
      <div class="wrap">
        <div class="nums">
          <div class="num-item" v-for="(n, i) in nums" :key="i">
            <div class="num">{{ n.value }}<span class="num-unit">{{ n.unit }}</span></div>
            <div class="num-label">{{ n.label }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- 分屏二：契合（右文左视觉） -->
    <section class="sec alt" id="match">
      <div class="wrap split rev">
        <div class="split-txt">
          <div class="kicker">服务特色 · 精准匹配</div>
          <h2 class="h2">契合，比心动更重要</h2>
          <p class="p">涵盖 6 大类 29 个维度、131 个选项的恋爱偏好体系，
            男女差异化设计，并用行为数据持续优化，把最契合的人带到你面前。</p>
          <div class="cloud">
            <span class="pill" v-for="(t, i) in preference" :key="i">{{ t }}</span>
          </div>
        </div>
        <div class="split-vis">
          <img v-if="imgs.match" class="vis-img" :src="imgs.match" alt="29 维度精准匹配" />
          <div class="match-vis" v-else>
            <div class="match-card left"><i class="ca ca-male"></i></div>
            <div class="match-heart"><i class="el-icon-star-on"></i></div>
            <div class="match-card right"><i class="ca ca-female"></i></div>
            <div class="match-tip">29 维度偏好 · 同城推荐 · 智能算法</div>
          </div>
        </div>
      </div>
    </section>

    <!-- 分屏三：成为更好的自己 -->
    <section class="sec" id="grow">
      <div class="wrap split">
        <div class="split-txt">
          <div class="kicker">服务特色 · 成长社交</div>
          <h2 class="h2">成长，让优秀被看见</h2>
          <p class="p">魅力指数由六个维度综合评估——既看你为自己做的努力，也看别人给你的关注，
            并生成专属提升建议；以动态广场、恋爱人格测评为纽带，弱化"硬件比拼"的尴尬。</p>
          <div class="dim-grid">
            <div class="dim" v-for="(d, i) in dims" :key="i">
              <i :class="d.icon"></i>{{ d.name }}
            </div>
          </div>
        </div>
        <div class="split-vis">
          <img v-if="imgs.grow" class="vis-img" :src="imgs.grow" alt="六维魅力指数" />
          <div class="grow-vis" v-else>
            <div class="grow-ring">
              <div class="grow-center">
                <div class="grow-key">魅力指数</div>
                <div class="grow-sub">六维综合评估</div>
              </div>
            </div>
            <div class="grow-note">评分用于给建议，不用于分高低</div>
          </div>
        </div>
      </div>
    </section>

    <!-- 承诺 -->
    <section class="sec alt" id="promise">
      <div class="wrap">
        <div class="block-head">
          <div class="kicker">服务理念</div>
          <h2 class="h2 center">我们的承诺</h2>
          <p class="p center">针对婚恋行业普遍存在的资料造假、套路收费、算法限流、隐私泄露等乱象，伊颂郑重承诺：</p>
        </div>
        <div class="grid g3">
          <div class="gcard pad" v-for="(p, i) in promises" :key="i">
            <div class="row-icon" :class="p.icon"></div>
            <div class="row-body">
              <div class="li-title">{{ p.title }}</div>
              <div class="li-text">{{ p.text }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务内容 -->
    <section class="sec" id="service">
      <div class="wrap">
        <div class="block-head">
          <div class="kicker">服务内容</div>
          <h2 class="h2 center">覆盖相识、相知到相恋的每一步</h2>
          <p class="p center">邀请好友注册还可获得红豆奖励，让缘分在传递中生长。</p>
        </div>
        <div class="grid g3">
          <div class="scard" v-for="(s, i) in services" :key="i">
            <div class="row-icon" :class="s.icon"></div>
            <div class="li-title">{{ s.name }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- 结尾 CTA -->
    <section class="cta">
      <div class="orb o3"></div>
      <div class="wrap">
        <h2 class="cta-title">在伊颂，认真的人终会被认真对待</h2>
        <p class="cta-sub">愿你在伊颂，遇见心动，也遇见余生。</p>
        <button class="btn white" @click="to('/download')"><i class="el-icon-download"></i> 立即下载伊颂</button>
      </div>
    </section>

    <footer class="footer">
      <div class="wrap">
        <div class="doc-links">
          <!-- 协议/文档属于合规阅读场景，新窗口打开，不把人从首页带走；用真实 href 而非 click 跳转，保留中键/右键新开能力 -->
          <a v-for="(d, i) in docs" :key="i" class="doc-link" :href="'/pages/detail/' + d.id + '.html'"
            target="_blank" rel="noopener noreferrer">{{ d.name }}</a>
        </div>
        <div class="copyright-row">
          <div class="copyright">© {{ year }} {{ companyShort }} 版权所有</div>
          <!-- 备案信息按工信部要求固定展示并链至官方核验入口；完整运营主体与证照由「证照公示」文档承载 -->
          <div class="copyright">
            <a class="beian" :href="beianUrl" target="_blank" rel="noopener noreferrer">{{ icpNo }}</a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  import config from '@/utils/config'

  export default {
    name: 'SiteHome',
    data() {
      return {
        navSolid: false,
        active: '',
        menus: [{
          id: 'value',
          name: '价值观'
        }, {
          id: 'ai',
          name: 'AI 能力'
        }, {
          id: 'verify',
          name: '真实认证'
        }, {
          id: 'match',
          name: '精准匹配'
        }, {
          id: 'promise',
          name: '我们的承诺'
        }, {
          id: 'service',
          name: '服务内容'
        }],
        values: [{
          key: '真实',
          text: '用技术与合规守住交友的底线，让每一个人都确有其人。'
        }, {
          key: '真诚',
          text: '用兴趣与话题弱化硬件比拼，让沟通有话题、有温度。'
        }, {
          key: '真心',
          text: '用专业与温度提升脱单效率，把人生大事变靠谱。'
        }],
        // 首屏信任状：均为已上线能力，文案统一 6 字保证两列对齐
        heroChips: [{
          icon: 'ca ca-face',
          text: '真人活体核验'
        }, {
          icon: 'ca ca-edu',
          text: '官方学历核验'
        }, {
          icon: 'ca ca-mbti',
          text: '恋爱人格测评'
        }, {
          icon: 'ca ca-preference',
          text: '多维精准匹配'
        }],
        // 手机屏模拟内容：六项对应官方七大核心功能，文案统一 6 字
        phoneRows: [{
          icon: 'ca ca-city',
          text: '同城缘分推荐'
        }, {
          icon: 'ca ca-message',
          text: '私密私信聊天'
        }, {
          icon: 'ca ca-moments',
          text: '动态广场互动'
        }, {
          icon: 'ca ca-mbti',
          text: '恋爱人格测评'
        }, {
          icon: 'ca ca-active',
          text: '魅力指数成长'
        }, {
          icon: 'ca ca-customer-service',
          text: '智能恋爱顾问'
        }],
        // 三项标题换为伊颂自有口径，正文描述仍逐字取官方演示介绍 PPT
        visions: [{
          key: '伊颂愿景',
          text: '成为中国最值得信赖的婚恋交友平台'
        }, {
          key: '伊颂使命',
          text: '让优质单身人群高效遇见对的人'
        }, {
          key: '伊颂价值观',
          text: '伊遇良缘，颂赴余生'
        }],
        // 面向 C 端只讲真实、匹配与陪伴三项能力，风控类能力不在此宣传
        aiPowers: [{
          icon: 'ca ca-camera',
          title: 'AI 美颜检测',
          text: '5 项美颜指标逐项检测，叠加网图溯源与 AI 生成图识别。'
        }, {
          icon: 'ca ca-preference',
          title: 'AI 精准匹配',
          text: '6 大类 29 维度 131 选项，男女差异化持续调优。'
        }, {
          icon: 'ca ca-customer-service',
          title: 'AI 恋爱顾问',
          text: '7×24 小时恋爱婚姻专业咨询，基于通义大模型。'
        }],
        verify: [{
          icon: 'ca ca-idcard',
          title: '实名认证',
          text: '对接公安权威数据，核验身份证件真实性。'
        }, {
          icon: 'ca ca-face',
          title: '真人认证',
          text: '人脸活体比对确认本人，拦截 AI 换脸。'
        }, {
          icon: 'ca ca-edu',
          title: '学历认证',
          text: '学信网 NCSS 官方在线核验学历学位。'
        }, {
          icon: 'ca ca-work',
          title: '工作认证',
          text: '企业邮箱、薪资流水佐证职业信息。'
        }],
        // 数字均取自官方文档与后端接口的可数事实，不做估算型宣传数字
        nums: [{
          value: '4',
          unit: '重',
          label: '实名真人认证'
        }, {
          value: '29',
          unit: '维',
          label: '恋爱偏好匹配'
        }, {
          value: '6',
          unit: '维',
          label: '魅力指数评估'
        }, {
          value: '7',
          unit: '大',
          label: '核心功能覆盖'
        }],
        // 偏好维度统一四字，8 项按 4 列× 2 行对齐
        preference: ['年龄区间', '身高范围', '学历层次', '职业类型', '所在地域', '婚育观念', '生活方式', '同城距离'],
        // 六维魅力构成：与后端 ca_charm 计分维度逐一对应
        // （CharmTask.SCORE_DIMENSIONS = profile / attract / login / interaction / moments / preference）
        dims: [{
          icon: 'ca ca-profile',
          name: '资料完善'
        }, {
          icon: 'ca ca-dianzan2-copy',
          name: '受关注度'
        }, {
          icon: 'ca ca-time',
          name: '登录频次'
        }, {
          icon: 'ca ca-message',
          name: '互动活跃'
        }, {
          icon: 'ca ca-moments',
          name: '动态发布'
        }, {
          icon: 'ca ca-preference',
          name: '恋爱偏好'
        }],
        // 官方六条承诺，逐字取自演示介绍 PPT“我们的承诺”页
        promises: [{
          icon: 'ca ca-checked',
          title: '真实优先',
          text: '严格核验身份与资料，坚决清理虚假账号与婚托。'
        }, {
          icon: 'ca ca-credit',
          title: '诚信收费',
          text: '明码标价、自愿消费，不诱导充值、不套路推销。'
        }, {
          icon: 'ca ca-recommend',
          title: '公平推荐',
          text: '不以“限流逼单”操控匹配，推荐服务于真实需求。'
        }, {
          icon: 'ca ca-passwd',
          title: '隐私至上',
          text: '精细化隐私设置，敏感信息须授权方可展示。'
        }, {
          icon: 'ca ca-flag',
          title: '安全守护',
          text: '账号实名可追溯，异常行为及时提醒，见面前后有提示。'
        }, {
          icon: 'ca ca-refresh',
          title: '持续进化',
          text: 'AI 模型每日迭代，匹配与体验持续优化。'
        }],
        services: [{
          icon: 'ca ca-recommend',
          name: '同城推荐交友'
        }, {
          icon: 'ca ca-message',
          name: '私信聊天互动'
        }, {
          icon: 'ca ca-moments',
          name: '动态广场分享'
        }, {
          icon: 'ca ca-mbti',
          name: '恋爱人格测评'
        }, {
          icon: 'ca ca-active',
          name: '魅力提升指导'
        }, {
          icon: 'ca ca-vip',
          name: '会员增值服务'
        }],
        // 配图槽位：图到位即自动替换 CSS 模拟视觉，不需再改模板
        imgs: {
          hero: '',
          match: '',
          verify: '',
          grow: ''
        },
        // 协议/公示文档由后端 ca_pageset 维护，站内路由 /pages/detail/{id}.html
        docs: [{
          id: 1,
          name: '关于伊颂'
        }, {
          id: 2,
          name: '证照公示'
        }, {
          id: 3,
          name: '用户服务协议'
        }, {
          id: 4,
          name: '用户隐私协议'
        }, {
          id: 11,
          name: '增值服务协议'
        }, {
          id: 12,
          name: 'SDK 集成说明'
        }]
      }
    },
    computed: {
      appName() {
        return config.appDownload.appName
      },
      slogan() {
        return config.appDownload.slogan
      },
      motto() {
        return config.appDownload.motto
      },
      companyShort() {
        return config.appDownload.companyShort
      },
      icpNo() {
        return config.appDownload.icpNo
      },
      beianUrl() {
        return config.appDownload.beianUrl
      },
      year() {
        return new Date().getFullYear()
      }
    },
    mounted() {
      window.addEventListener('scroll', this.onScroll)
      this.onScroll()
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.onScroll)
    },
    methods: {
      onScroll() {
        this.navSolid = window.scrollY > 60
        // 高亮当前所在区块：取顶部已越过导航线的最后一个 section
        let current = ''
        this.menus.forEach(m => {
          const el = document.getElementById(m.id)
          if (el && el.getBoundingClientRect().top <= 120) current = m.id
        })
        this.active = current
      },
      go(id) {
        const el = document.getElementById(id)
        if (!el) return
        // 固定导航高 68px，锚点定位需补偿，否则区块标题被遮挡
        window.scrollTo({
          top: el.getBoundingClientRect().top + window.scrollY - 68,
          behavior: 'smooth'
        })
      },
      scrollTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      },
      to(path) {
        this.$router.push(path)
      }
    }
  }
</script>

<style scoped>
  /* 主题色与下载落地页(download.vue)/登录页同一口径：主色 #dc2380，粉渐变 #ff6a8e→#ffd6e0 */
  .site {
    font-family: "PingFang SC", "Microsoft YaHei", Helvetica, Arial, sans-serif;
    color: #2c2c34;
    background: #fff;
  }

  .wrap {
    width: 100%;
    max-width: 1180px;
    margin: 0 auto;
    padding: 0 24px;
    box-sizing: border-box;
  }

  .wrap.narrow {
    max-width: 980px;
  }

  /* ---------- 导航 ---------- */
  .nav {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 68px;
    z-index: 100;
    transition: background .25s, box-shadow .25s;
  }

  .nav.solid {
    background: rgba(255, 255, 255, .94);
    box-shadow: 0 2px 12px rgba(220, 35, 128, .1);
    backdrop-filter: blur(10px);
  }

  .nav.solid .nav-name,
  .nav.solid .nav-item {
    color: #2c2c34;
  }

  .nav.solid .nav-logo-icon {
    color: #dc2380;
  }

  .nav.solid .nav-item.on {
    color: #dc2380;
  }

  .nav-in {
    max-width: 1180px;
    height: 100%;
    margin: 0 auto;
    padding: 0 24px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }

  .nav-brand {
    display: flex;
    align-items: center;
    cursor: pointer;
    flex: none;
  }

  /* 图标库里的品牌 LOGO 字形直接作导航标识 */
  .nav-logo-icon {
    font-size: 30px;
    line-height: 1;
    color: #fff;
    transition: color .25s;
  }

  .nav-name {
    margin-left: 10px;
    font-size: 19px;
    font-weight: 700;
    letter-spacing: 3px;
    color: #fff;
  }

  .nav-menu {
    flex: 1;
    display: flex;
    justify-content: center;
    gap: 28px;
  }

  .nav-item {
    font-size: 14px;
    color: rgba(255, 255, 255, .9);
    cursor: pointer;
    transition: color .2s;
  }

  .nav-item:hover {
    color: #fff;
  }

  .nav-item.on {
    color: #fff5f8;
    font-weight: 600;
  }

  .nav-ops {
    display: flex;
    align-items: center;
    gap: 16px;
    flex: none;
  }

  /* 导航下载按钮：直接用 el-button 的 small 尺寸，只需抹平默认配色 */
  .nav-dl,
  .nav-dl:hover,
  .nav-dl:focus,
  .nav-dl:active {
    border: none;
    border-radius: 16px;
    height: 32px;
    padding: 0 16px;
    font-size: 12px;
    color: #dc2380;
    background: #fff;
    box-shadow: 0 6px 16px rgba(150, 20, 85, .22);
  }

  .nav-dl:hover,
  .nav-dl:focus {
    background: #fff5f8;
  }

  /* ---------- 首屏 ---------- */
  .hero {
    position: relative;
    background: linear-gradient(165deg, #ff6a8e 0%, #ff8fab 42%, #ffd6e0 100%);
    color: #fff;
    /* 左文右图：文字左对齐才符合阅读动线 */
    text-align: left;
    padding: 104px 24px 92px;
    overflow: hidden;
  }

  .hero-in {
    position: relative;
    z-index: 1;
    max-width: 1132px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 56px;
  }

  /* 图标库 LOGO 作超大半透明水印，压在渐变底上 */
  .hero-mark {
    position: absolute;
    right: -30px;
    bottom: -100px;
    font-size: 460px;
    line-height: 1;
    color: rgba(255, 255, 255, .1);
    pointer-events: none;
    z-index: 0;
  }

  .orb {
    position: absolute;
    border-radius: 50%;
    filter: blur(60px);
    pointer-events: none;
  }

  .orb.o1 {
    width: 46vw;
    height: 46vw;
    top: -14%;
    right: -8%;
    background: radial-gradient(circle, rgba(255, 255, 255, .8) 0%, transparent 70%);
  }

  .orb.o2 {
    width: 40vw;
    height: 40vw;
    bottom: -18%;
    left: -10%;
    background: radial-gradient(circle, rgba(217, 87, 131, .55) 0%, transparent 72%);
  }

  .orb.o3 {
    width: 34vw;
    height: 34vw;
    top: -20%;
    left: 30%;
    background: radial-gradient(circle, rgba(255, 255, 255, .26) 0%, transparent 70%);
  }

  .hero-vis {
    position: relative;
    z-index: 1;
    flex: none;
    display: flex;
    justify-content: center;
  }

  .phone {
    width: 232px;
    height: 468px;
    border-radius: 38px;
    background: #1c1016;
    padding: 10px;
    box-shadow: 0 30px 60px rgba(120, 10, 60, .32);
  }

  .phone-notch {
    width: 74px;
    height: 16px;
    border-radius: 0 0 10px 10px;
    background: #1c1016;
    margin: 0 auto;
    position: relative;
    z-index: 2;
  }

  .phone-screen {
    height: 100%;
    margin-top: -16px;
    border-radius: 28px;
    background: linear-gradient(170deg, #fff 0%, #ffeaf1 55%, #ffd6e0 100%);
    padding: 18px 14px;
    box-sizing: border-box;
  }

  .phone-head {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 22px 2px 14px;
    border-bottom: 1px solid #fbdce8;
  }

  .phone-logo {
    font-size: 32px;
    line-height: 1;
    color: #dc2380;
  }

  .phone-name {
    font-size: 18px;
    font-weight: 700;
    letter-spacing: 2px;
    color: #dc2380;
  }

  .phone-sub {
    margin-top: 3px;
    font-size: 10px;
    letter-spacing: 1px;
    color: #a04068;
  }

  .phone-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 10px;
    padding: 11px 12px;
    border-radius: 12px;
    background: rgba(255, 255, 255, .8);
    box-shadow: 0 4px 12px rgba(220, 35, 128, .07);
    font-size: 12px;
    color: #4a3540;
  }

  .phone-row i {
    font-size: 16px;
    color: #dc2380;
  }

  .hero-txt {
    position: relative;
    z-index: 1;
    flex: 1;
    min-width: 0;
  }

  .h-hero {
    margin: 0;
    font-size: 58px;
    font-weight: 800;
    letter-spacing: 8px;
    /* 显式给行高：不依赖各浏览器的 normal，避免大字与副标题贴叠 */
    line-height: 1.35;
  }

  .p-hero {
    font-size: 19px;
    line-height: 1.6;
    margin: 14px 0 30px;
    opacity: .95;
    letter-spacing: 1px;
  }

  .hero-motto {
    display: inline-block;
    margin-bottom: 28px;
    padding: 8px 20px;
    border-radius: 20px;
    background: rgba(255, 255, 255, .2);
    border: 1px solid rgba(255, 255, 255, .42);
    font-size: 15px;
    letter-spacing: 3px;
  }

  .hero-btns {
    display: flex;
    justify-content: flex-start;
    gap: 16px;
    flex-wrap: wrap;
  }

  .hero-chips {
    list-style: none;
    padding: 0;
    margin: 34px 0 0;
    max-width: 460px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 14px 24px;
  }

  .hero-chips li {
    display: flex;
    align-items: center;
    gap: 9px;
    font-size: 14px;
    letter-spacing: 1px;
  }

  .hero-chips i {
    font-size: 18px;
  }

  .hero-down {
    position: relative;
    margin-top: 54px;
    font-size: 22px;
    opacity: .8;
    cursor: pointer;
    animation: bounce 1.8s infinite;
  }

  @keyframes bounce {

    0%,
    100% { transform: translateY(0); }
    50% { transform: translateY(8px); }
  }

  /* ---------- 按钮 ---------- */
  .btn {
    border-radius: 26px;
    height: 50px;
    padding: 0 32px;
    font-size: 16px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    transition: transform .2s, background .2s;
  }

  .btn:hover {
    transform: translateY(-2px);
  }

  .btn.solid {
    border: none;
    background: #dc2380;
    color: #fff;
    box-shadow: 0 10px 24px rgba(120, 10, 60, .26);
  }

  .btn.solid:hover {
    background: #e83f95;
  }

  .btn.line {
    border: 1px solid rgba(255, 255, 255, .85);
    background: transparent;
    color: #fff;
  }

  .btn.white {
    border: none;
    background: #fff;
    color: #dc2380;
    box-shadow: 0 10px 26px rgba(90, 8, 45, .28);
  }

  /* ---------- 区块通用 ---------- */
  .sec {
    padding: 108px 0;
  }

  .sec.alt {
    background: #fff6f9;
  }

  .block-head {
    text-align: center;
    margin-bottom: 48px;
  }

  .kicker {
    font-size: 13px;
    letter-spacing: 4px;
    font-weight: 600;
    color: #dc2380;
  }

  .h2 {
    font-size: 42px;
    line-height: 1.3;
    font-weight: 700;
    margin: 16px 0 20px;
  }

  .h2.center {
    text-align: center;
  }

  .h-say {
    font-size: 46px;
    line-height: 1.45;
    font-weight: 700;
    text-align: center;
    margin: 18px 0 26px;
  }

  .h-say b {
    color: #dc2380;
  }

  .p {
    font-size: 16px;
    line-height: 2;
    color: #5f5f6b;
    margin: 0 0 24px;
  }

  .p.center {
    text-align: center;
    max-width: 820px;
    margin-left: auto;
    margin-right: auto;
  }

  .p-center {
    text-align: center;
    font-size: 16px;
    line-height: 2;
    color: #5f5f6b;
    max-width: 820px;
    margin: 0 auto 40px;
  }

  .p-center.lead {
    margin-top: 44px;
    margin-bottom: 0;
    color: #7a7a86;
  }

  /* ---------- 价值观三卡 ---------- */
  .value-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 22px;
  }

  .value-item {
    background: #fff;
    border: 1px solid #f7e2ea;
    border-radius: 18px;
    padding: 32px 24px;
    text-align: center;
    box-shadow: 0 10px 26px rgba(220, 35, 128, .06);
  }

  .value-key {
    font-size: 26px;
    font-weight: 700;
    letter-spacing: 6px;
    color: #dc2380;
  }

  .value-text {
    margin-top: 14px;
    font-size: 14px;
    line-height: 1.9;
    color: #666;
  }

  /* 使命 / 愿景 / 价值观：标题为伊颂自有口径，正文逐字取自官方演示 PPT；三项描述统一单行展示 */
  .vision-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 22px;
    margin-top: 22px;
  }

  .vision-item {
    padding: 22px 20px;
    border-radius: 16px;
    background: #fff6f9;
    border: 1px solid #f7e2ea;
    text-align: center;
  }

  .vision-key {
    font-size: 13px;
    letter-spacing: 3px;
    color: #a04068;
  }

  .vision-text {
    margin-top: 10px;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.7;
    color: #2c2c34;
  }

  /* 配图槽：图片到位后统一按此规格呈现 */
  .vis-img {
    max-width: 100%;
    border-radius: 24px;
    box-shadow: 0 18px 40px rgba(220, 35, 128, .16);
  }

  /* ---------- 图文分屏 ---------- */
  .split {
    display: flex;
    align-items: center;
    gap: 72px;
  }

  .split.rev {
    flex-direction: row-reverse;
  }

  .split-txt {
    flex: 1;
    min-width: 0;
  }

  .split-vis {
    flex: 1;
    min-width: 0;
    display: flex;
    justify-content: center;
  }

  .list {
    list-style: none;
    padding: 0;
    margin: 30px 0 0;
  }

  .list li {
    display: flex;
    gap: 14px;
    margin-bottom: 20px;
  }

  .li-icon {
    flex: none;
    width: 40px;
    height: 40px;
    border-radius: 12px;
    background: linear-gradient(135deg, #ff6a8e, #dc2380);
    color: #fff;
    font-size: 19px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .li-title {
    font-size: 16px;
    font-weight: 600;
    color: #2c2c34;
    margin-bottom: 6px;
  }

  .li-text {
    font-size: 14px;
    line-height: 1.85;
    color: #6b6b76;
  }

  /* 卡片内介绍统一 2 行起，避免行数不一致导致参差 */
  .grid .li-text {
    min-height: 52px;
  }

  /* 认证卡改 2×2 网格叠放：保留倾斜但不再互相压字 */
  .doc-stack {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    width: 340px;
  }

  .doc-card {
    width: 100%;
    height: 118px;
    border-radius: 16px;
    background: #fff;
    box-shadow: 0 16px 34px rgba(220, 35, 128, .14);
    border: 1px solid #fbe6ee;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    color: #dc2380;
    font-size: 15px;
    font-weight: 600;
  }

  .doc-card i {
    font-size: 28px;
  }

  .doc-card.c1 { transform: rotate(-3deg); }
  .doc-card.c2 { transform: rotate(2.5deg); }
  .doc-card.c3 { transform: rotate(2.5deg); }
  .doc-card.c4 { transform: rotate(-2.5deg); }

  /* ---------- 大数字 ---------- */
  .nums {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 26px;
    text-align: center;
  }

  .num {
    font-size: 68px;
    font-weight: 800;
    line-height: 1;
    background: linear-gradient(135deg, #ff6a8e, #dc2380);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }

  .num-unit {
    font-size: 22px;
    margin-left: 4px;
    font-weight: 600;
  }

  .num-label {
    margin-top: 14px;
    font-size: 15px;
    color: #6b6b76;
  }

  /* ---------- 匹配视觉 ---------- */
  .match-vis {
    position: relative;
    width: 320px;
    height: 300px;
  }

  .match-card {
    position: absolute;
    top: 40px;
    width: 132px;
    height: 168px;
    border-radius: 18px;
    background: #fff;
    border: 1px solid #fbe6ee;
    box-shadow: 0 16px 34px rgba(220, 35, 128, .14);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 44px;
    color: #ff8fab;
  }

  .match-card.left { left: 0; transform: rotate(-6deg); }
  .match-card.right { right: 0; transform: rotate(6deg); color: #dc2380; }

  .match-heart {
    position: absolute;
    top: 100px;
    left: 50%;
    transform: translateX(-50%);
    width: 62px;
    height: 62px;
    border-radius: 50%;
    background: linear-gradient(135deg, #ff6a8e, #dc2380);
    color: #fff;
    font-size: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 12px 26px rgba(220, 35, 128, .3);
    z-index: 2;
  }

  .match-tip {
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 0;
    text-align: center;
    font-size: 13px;
    color: #a04068;
  }

  /* 偏好维度 4 列 × 2 行，列与列严格对齐 */
  .cloud {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    margin-top: 28px;
  }

  .pill {
    font-size: 14px;
    padding: 9px 18px;
    border-radius: 19px;
    background: #fff;
    border: 1px solid #f4d7e2;
    color: #a04068;
    text-align: center;
    box-shadow: 0 4px 12px rgba(220, 35, 128, .06);
  }

  /* 魅力六维 3 列 × 2 行，与后端 ca_charm 计分维度对应 */
  .dim-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
    margin-top: 28px;
  }

  .dim {
    display: flex;
    align-items: center;
    font-size: 14px;
    padding: 11px 16px;
    border-radius: 12px;
    background: #fff;
    border: 1px solid #f4d7e2;
    color: #6b6b76;
  }

  .dim i {
    font-size: 16px;
    color: #dc2380;
    margin-right: 7px;
  }

  .grow-vis {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .grow-ring {
    width: 288px;
    height: 288px;
    border-radius: 50%;
    border: 4px dashed #f4a9c4;
    background: radial-gradient(circle, #fff 55%, #ffeaf1 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 18px 40px rgba(220, 35, 128, .12);
  }

  .grow-center {
    text-align: center;
  }

  .grow-key {
    font-size: 26px;
    font-weight: 700;
    color: #dc2380;
    letter-spacing: 3px;
  }

  .grow-sub {
    margin-top: 10px;
    font-size: 14px;
    color: #a04068;
  }

  .grow-note {
    margin-top: 22px;
    font-size: 13px;
    color: #8c8c96;
  }

  /* ---------- 卡片网格 ---------- */
  .grid {
    display: grid;
    gap: 20px;
  }

  .grid.g3 {
    grid-template-columns: repeat(3, 1fr);
  }

  .gcard {
    display: flex;
    gap: 14px;
    padding: 24px 22px;
    border-radius: 16px;
    background: #fff;
    border: 1px solid #f7e2ea;
    box-shadow: 0 10px 26px rgba(220, 35, 128, .06);
  }

  .gcard.pad {
    padding: 28px 26px;
  }

  .row-icon {
    flex: none;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #fdeaf2;
    color: #dc2380;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .row-body {
    flex: 1;
    min-width: 0;
  }

  /* ---------- 服务卡 ---------- */
  .scard {
    background: #fff;
    border: 1px solid #f7e2ea;
    border-radius: 16px;
    padding: 30px 20px;
    text-align: center;
    box-shadow: 0 10px 26px rgba(220, 35, 128, .06);
  }

  .scard .row-icon {
    margin: 0 auto 14px;
    width: 48px;
    height: 48px;
    font-size: 23px;
  }

  /* ---------- 结尾 CTA ---------- */
  .cta {
    position: relative;
    background: linear-gradient(135deg, #ff6a8e 0%, #dc2380 100%);
    color: #fff;
    text-align: center;
    padding: 92px 24px;
    overflow: hidden;
  }

  .cta-title {
    position: relative;
    font-size: 34px;
    font-weight: 700;
    margin: 0 0 16px;
  }

  .cta-sub {
    position: relative;
    font-size: 16px;
    opacity: .92;
    margin: 0 0 34px;
  }

  .cta .btn {
    position: relative;
  }

  /* ---------- 页脚 ---------- */
  .footer {
    background: #241a20;
    color: rgba(255, 255, 255, .68);
    padding: 40px 24px;
    text-align: center;
    font-size: 13px;
    line-height: 2;
  }

  .doc-links {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 24px;
    margin-bottom: 14px;
  }

  /* 版权与备案：PC 同行展示，窄屏自然换行（不靠断点硬切，避开中等宽度下的尴尬） */
  .copyright-row {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0 18px;
  }

  .doc-link,
  .doc-link:visited {
    color: rgba(255, 255, 255, .82);
    text-decoration: none;
  }

  .doc-link:hover {
    color: #ff9ec4;
  }

  /* 备案号链接：颜色沿用页脚正文，悬停提亮 */
  .beian,
  .beian:visited {
    color: rgba(255, 255, 255, .68);
    text-decoration: none;
  }

  .beian:hover {
    color: #ff9ec4;
  }

  /* ---------- 响应式 ---------- */
  @media only screen and (max-width: 992px) {
    .hero-in {
      flex-direction: column;
      text-align: center;
    }

    .hero {
      text-align: center;
    }

    .hero-btns,
    .hero-chips {
      justify-content: center;
      margin-left: auto;
      margin-right: auto;
    }

    .hero-mark {
      font-size: 320px;
      bottom: -60px;
    }

    .split {
      flex-direction: column;
      gap: 44px;
    }

    .split.rev {
      flex-direction: column;
    }

    /* 三列时窄屏会折行，改单列保证描述仍各占一行 */
    .vision-grid {
      grid-template-columns: 1fr;
    }

    .grid.g3 {
      grid-template-columns: repeat(2, 1fr);
    }

    .num {
      font-size: 54px;
    }
  }

  @media only screen and (max-width: 768px) {
    .nav-menu {
      display: none;
    }

    .sec {
      padding: 64px 0;
    }

    .hero {
      padding: 92px 18px 60px;
    }

    .h-hero {
      font-size: 38px;
      letter-spacing: 5px;
    }

    .p-hero {
      font-size: 15px;
    }

    .h2,
    .h-say {
      font-size: 27px;
    }

    .cta-title {
      font-size: 24px;
    }

    .value-grid,
    .vision-grid,
    .grid.g3,
    .nums {
      grid-template-columns: 1fr;
    }

    .cloud,
    .dim-grid,
    .hero-chips {
      grid-template-columns: repeat(2, 1fr);
    }

    .nums {
      gap: 34px;
    }

    .doc-stack,
    .match-vis {
      transform: scale(.86);
    }
  }
</style>
